(function () {
  if (window.LumoProductVariantSync) return;

  var COLOR_NAME_BY_HEX = {
    "#1C1A1A": "Black",
    "#E8E8E8": "White",
    "#B9633E": "Brown",
    "#799FBF": "Blue",
    "#A83947": "Red",
    "#D5BA78": "Yellow"
  };

  function normalizeHex(value) {
    var next = String(value || "").trim();
    if (!next) return "";
    if (next.charAt(0) !== "#") next = "#" + next;
    if (/^#[0-9a-f]{3}$/i.test(next)) {
      next = "#" + next.slice(1).split("").map(function (char) {
        return char + char;
      }).join("");
    }
    return /^#[0-9a-f]{6}$/i.test(next) ? next.toUpperCase() : "";
  }

  function colorNameFromHex(value, fallback) {
    return COLOR_NAME_BY_HEX[normalizeHex(value)] || fallback || "";
  }

  function formatMoney(cents) {
    var currency = "USD";
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      currency = window.Shopify.currency.active;
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return "$" + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function optionMatches(variant, position, value) {
    if (!value) return true;
    return String(variant["option" + position] || "") === String(value);
  }

  function readVariants(form) {
    var data = form.querySelector("[data-lumo-product-variants]");
    if (!data) return [];

    try {
      var parsed = JSON.parse(data.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function readCurrentVariant(variants, id) {
    var selected = variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
    return selected || variants.find(function (variant) { return variant.available; }) || variants[0] || null;
  }

  function VariantSync(form) {
    this.form = form;
    this.variants = readVariants(form);
    this.idInput = form.querySelector("[data-lumo-variant-id], input[name='id']");
    this.price = form.querySelector("[data-lumo-product-price]");
    this.submit = form.querySelector("button[type='submit']");
    if (this.submit && !this.submit.dataset.lumoDefaultText) {
      this.submit.dataset.lumoDefaultText = this.submit.textContent;
    }
    this.materialPicker = form.querySelector("[data-lumo-material-picker]");
    this.materialButtons = Array.prototype.slice.call(form.querySelectorAll("[data-lumo-material-option]"));
    this.state = {
      material: "",
      grip: "",
      edge: ""
    };
  }

  VariantSync.prototype.init = function () {
    var current = readCurrentVariant(this.variants, this.idInput && this.idInput.value);
    if (!current || !this.idInput) return;

    this.state.material = current.option1 || "";
    this.state.grip = colorNameFromHex(this.readCustomizerColor("[data-lumo-grip-input]"), current.option2 || "");
    this.state.edge = colorNameFromHex(this.readCustomizerColor("[data-lumo-edge-input]"), current.option3 || "");
    this.bind();
    this.update();
    this.refreshVariants();
  };

  VariantSync.prototype.refreshVariants = function () {
    if (typeof window.fetch !== "function" || window.location.pathname.indexOf("/products/") === -1) return;

    var self = this;
    var productUrl = new URL(window.location.href);
    var country = productUrl.searchParams.get("country") || (window.Shopify && window.Shopify.country);
    var currency = productUrl.searchParams.get("currency") || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
    productUrl.pathname = productUrl.pathname.replace(/\/$/, "") + ".js";
    productUrl.search = "";
    if (country) productUrl.searchParams.set("country", country);
    if (currency) productUrl.searchParams.set("currency", currency);

    window.fetch(productUrl.toString(), {
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Product data request failed.");
      return response.json();
    }).then(function (product) {
      if (!product || !Array.isArray(product.variants) || !product.variants.length) return;
      self.variants = product.variants;
      self.update();
    }).catch(function () {});
  };

  VariantSync.prototype.readCustomizerColor = function (selector) {
    var input = this.form.querySelector(selector);
    return input ? input.value : "";
  };

  VariantSync.prototype.bind = function () {
    var self = this;

    this.materialButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        self.state.material = button.dataset.lumoMaterialOption || "";
        self.update();
      });
    });

    this.form.addEventListener("lumo:paddle-customizer:update", function (event) {
      var state = event.detail && event.detail.state;
      if (!state) return;
      self.state.grip = colorNameFromHex(state.grip_color, self.state.grip);
      self.state.edge = colorNameFromHex(state.edge_color, self.state.edge);
      self.update();
    });
  };

  VariantSync.prototype.findVariant = function () {
    var available = this.variants.filter(function (variant) { return variant.available; });
    var candidates = available.length ? available : this.variants;
    var state = this.state;

    return candidates.find(function (variant) {
      return optionMatches(variant, 1, state.material) &&
        optionMatches(variant, 2, state.grip) &&
        optionMatches(variant, 3, state.edge);
    }) || candidates.find(function (variant) {
      return optionMatches(variant, 1, state.material) &&
        optionMatches(variant, 3, state.edge);
    }) || candidates.find(function (variant) {
      return optionMatches(variant, 1, state.material) &&
        optionMatches(variant, 2, state.grip);
    }) || candidates.find(function (variant) {
      return optionMatches(variant, 1, state.material);
    }) || candidates[0] || null;
  };

  VariantSync.prototype.updateButtons = function (variant) {
    var material = variant && variant.option1 ? variant.option1 : this.state.material;

    this.materialButtons.forEach(function (button) {
      button.setAttribute("aria-pressed", button.dataset.lumoMaterialOption === material ? "true" : "false");
    });
  };

  VariantSync.prototype.update = function () {
    var variant = this.findVariant();
    if (!variant || !this.idInput) return;

    this.state.material = variant.option1 || this.state.material;
    this.idInput.value = variant.id;
    this.updateButtons(variant);

    if (this.price) this.price.textContent = formatMoney(variant.price);
    if (this.submit) {
      this.submit.disabled = !variant.available;
      this.submit.textContent = variant.available ? this.submit.dataset.lumoDefaultText : "Sold out";
    }
  };

  function initAll() {
    document.querySelectorAll("form.lumo-native-product-route").forEach(function (form) {
      if (form.__lumoVariantSync) return;
      var sync = new VariantSync(form);
      form.__lumoVariantSync = sync;
      sync.init();
    });
  }

  window.LumoProductVariantSync = {
    initAll: initAll
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
